// Components/EditFacilites.jsx
import React, { useState, useEffect } from "react";
import api from "../../../../../../api/axios";

const EditFacilites = ({ open, onClose, facility, onUpdated }) => {
  const [facilityName, setFacilityName] = useState("");
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (facility && open) {
      setFacilityName(facility.name || "");
      setActive(facility.active ?? true);
    }
  }, [facility, open]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!facilityName || loading) return;

    try {
      setLoading(true);

      await api.put(`/pms/amenities/${facility.id}`, {
        name: facilityName,
        active,
      });

      if (onUpdated) onUpdated();
      onClose();
    } catch (error) {
      console.error("Update facility failed:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>

      <div className="modal d-block">
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h5>Edit Facility</h5>
              <button className="btn-close" onClick={onClose}></button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <label className="form-label">Facility Name</label>
                <input
                  className="form-control mb-3"
                  value={facilityName}
                  onChange={(e) => setFacilityName(e.target.value)}
                  required
                />

                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={active}
                    onChange={() => setActive(!active)}
                  />
                  <label className="form-check-label">Active</label>
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={onClose}>
                  Close
                </button>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    </>
  );
};

export default EditFacilites;
